import { request } from '@/request/request';
import { parameterChange } from '@/utils';

export default {
  // 搜索列表
  searchList(data) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/search/searchList?${parameterChange(data)}`,
      method: 'get',
      data,
    });
  },
};
